import { MDBBtnGroup, MDBBtn } from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import { CHART_TYPES } from "../helpers/constants";

export default function ChartTypeToggle({ chartType, setChartType }) {
  const { t } = useTranslation();

  return (
    <div className="d-flex justify-content-end mb-2">
      <MDBBtnGroup size="sm">
        {CHART_TYPES.map((type) => (
          <MDBBtn
            key={type}
            color={chartType === type ? "primary" : "light"}
            onClick={() => setChartType(type)}
          >
            {type === "line" ? t("Line") : t("Bar")}
          </MDBBtn>
        ))}
      </MDBBtnGroup>
    </div>
  );
}
